import React, { useState } from "react";
import { ShieldPlus } from "lucide-react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Input,
  Select,
  Button,
} from "./ui";

const CATEGORY_OPTIONS = [
  { value: "STAFF", label: "STAFF" },
  { value: "STUDENT", label: "STUDENT" },
  { value: "PARENT", label: "PARENT" },
];

const RoleForm = ({ onSubmit, loading }) => {
  const [formData, setFormData] = useState({
    roleName: "",
    category: "STAFF",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({
      roleName: "",
      category: "STAFF",
    });
  };

  return (
    <Card>
      <CardHeader className="border-b bg-neutral-50/50">
        <CardTitle className="flex items-center gap-2">
          <ShieldPlus className="h-5 w-5 text-primary-600 dark:text-primary-400 shrink-0" />
          <span>Create New Role</span>
        </CardTitle>
      </CardHeader>

      <CardContent className="p-4 sm:p-6">
        <form onSubmit={submitHandler} className="space-y-4">
          <Input
            label="Role Name"
            type="text"
            name="roleName"
            placeholder="e.g. Senior Accountant"
            value={formData.roleName}
            onChange={handleChange}
            required
          />

          <Select
            label="Category"
            name="category"
            value={formData.category}
            onChange={(val) => setFormData((prev) => ({ ...prev, category: val }))}
            options={CATEGORY_OPTIONS}
          />

          <Button
            type="submit"
            variant="primary"
            isLoading={loading}
            className="w-full"
          >
            {loading ? "Saving..." : "Create Role"}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default RoleForm;